<template>
  <a-tooltip
    :title="tooltipText"
    placement="top"
    :required="required"
  >
    <a-range-picker
      v-model:value="model"
      :format="format"
      :valueFormat="valueFormat"
      :disabled-date="disabledDateRage"
      :showTime="showTime"
      :style="style"
      @calendarChange="handleCalendarChange"
    />
  </a-tooltip>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { useDateRangeLimit } from "@/app/shared/composables/useDateRangeLimit";

import { PlanEspecial } from "@/app/common/types";
import { usePlanSearchRange } from "../../composables/usePlanDateRange";
import { RangeConfigKey } from "../../utils/planDatePicker";

interface Props {
  modelValue: string[] | null | undefined;
  configKey?: RangeConfigKey;
  defaultLimit?: number;
  defaultTypeRange?: "days" | "months";
  limitValue?: number; // forzar valor sin importar el plan del usuario
  typeRangeValue?: "days" | "months"; // forzar valor sin importar el plan del usuario
  format?: string;
  valueFormat?: string;
  showTime?: boolean | { format: string };
  required?: boolean;
  style?: null | Record<string, any>;
}

const props = withDefaults(
  defineProps<Props>(),
  {
    defaultLimit: undefined,
    defaultTypeRange: 'days',
    limitValue: undefined,
    typeRangeValue: undefined,
    configKey: RangeConfigKey.MessagingSearchRange,
    format: "DD/MM/YYYY",
    valueFormat: "YYYY-MM-DD",
    showTime: false,
    required: true,
    style: null,
  }
);

const emit = defineEmits<{
  (
    e: "update:modelValue",
    value: string[] | null
  ): void;
}>();

const model = computed({
  get: () => props.modelValue,
  set: (value) =>
    emit("update:modelValue", value),
});

const store = useStore();

const userData = computed(
  () => store.getters["getDataUser"]
);

const plan = computed(
  () => userData.value?.change_custom_plan?.plan
);

const isUnlimitedPlan = computed(
  () => plan.value === PlanEspecial
);

const {
  rangeLimit,
  typeRange,
  rangeLimitText,
} = usePlanSearchRange(
  props.defaultLimit,
  props.configKey,
  isUnlimitedPlan,
);

const defaultLimitC = computed(() => 
  props.limitValue !== undefined ? props.limitValue : (isUnlimitedPlan.value ? props.defaultLimit : rangeLimit.value)
);
const defaultTypeRangeC = computed(() => 
  (props.typeRangeValue !== undefined && props.typeRangeValue !== null) 
  ? props.typeRangeValue : (isUnlimitedPlan.value ? props.defaultTypeRange : typeRange.value)
);
// const isUnlimitedPlan = computed(
//   () => true
// );

const {
  handleCalendarChange,
  disabledDateRage,
} = useDateRangeLimit(
  defaultLimitC,
  defaultTypeRangeC,
  isUnlimitedPlan
);

const tooltipText = computed(() => {
  if (isUnlimitedPlan.value && !props.defaultLimit) {
    return "";
  }

  if (props.limitValue !== undefined && props.limitValue !== null) {
    const typeRangeText = defaultTypeRangeC.value === "days" ? "días" : "meses";
    return `Puedes seleccionar un rango máximo de ${props.limitValue} ${typeRangeText}`;
  }

  return `Puedes seleccionar un rango máximo de ${rangeLimitText.value}`;
});
</script>